import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  aDate() {
    return faker.date.past();
  },

  headline() {
    return faker.lorem.sentence();
  },

  subHeadline() {
    return faker.lorem.sentence();
  },

  showDate() {
    return Math.random() < 0.8;
  },

  showMore() {
    return Math.random() < 0.8;
  },

  text() {
    return faker.lorem.paragraphs();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(article, server) {
    let numArtists = faker.datatype.number({
      min: 1,
      max: 3,
    });

    article.update({
      artists: server.createList('artist', numArtists),
      categoryId: server.create('category', 'articleType'),
    });
  },
});
